import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CreateIcon from "@material-ui/icons/Create";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import { setEditingField, setFormFields } from "redux/actions/FormBuilder";
import { fetchError, fetchSuccess } from "redux/actions";
import AddIcon from "@material-ui/icons/Add";
import FieldOption from "./FieldOption";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CustomSelect from "@jumbo/Dashboards/Banner/CustomSelect";
import { dateFormat } from "@jumbo/utils/shamsiStandardFormat";

const generateUniqueId = () => {
  return (
    Date.now().toString(36) +
    Math.random()
      .toString(36)
      .substr(2, 9)
  );
};

const useStyles = makeStyles((theme) => ({
  fieldButton: {
    width: "100%",
    marginBottom: "16px",
  },
  formControl: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
  },
  textFieldLabel: {
    color: theme.palette.primary.main,
    fontSize: "14px",
    marginBottom: "14px",
  },
  cancleButton: {
    marginRight: "10px",
  },
  checkFieldsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
}));

const FieldSettings = () => {
  const classes = useStyles();

  const [selectedItem, setSelectedItem] = React.useState({});

  const dispatch = useDispatch();

  const { editingField, formFields, form } = useSelector(
    ({ formBuilder }) => formBuilder
  );
  const savedPolicy = form?.gradingOverrides?.[selectedItem?._id || selectedItem?.id];
  const advancedPolicy = savedPolicy && typeof savedPolicy === 'object' &&
    ['creditAll', 'exclude', 'acceptAny'].includes(savedPolicy.mode) ? savedPolicy : null;
  const policyText = advancedPolicy?.mode === 'creditAll' ? 'پاسخ صحیح برای همه'
    : advancedPolicy?.mode === 'exclude' ? 'حذف از آزمون'
    : advancedPolicy?.mode === 'acceptAny' ? advancedPolicy.answers.join(' یا ') : '';

  const handleSubmitChanges = () => {
    if (
      selectedItem.type === "RadioButton" &&
      !advancedPolicy &&
      selectedItem.examQuestionHasRightAnswer &&
      !selectedItem.examQuestionRightAnswer
    ) {
      dispatch(fetchError("لطفا پاسخ صحیح را انتخاب کنید"));
      return;
    }
    updateItems(selectedItem);
    dispatch(fetchSuccess("با موفقیت به روزرسانی شد"));
    dispatch(setEditingField(""));
    const element = document.getElementById(editingField);
    if (element) {
      const yOffset = -100;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const updateItems = (updatedValues) => {
    const updated = formFields.map((item) => {
      if ((item.id || item._id) === editingField) {
        return { ...item, ...updatedValues };
      }
      return item;
    });
    dispatch(setFormFields(updated));
  };

  useEffect(() => {
    if (editingField) {
      const currItem = formFields.find(
        (item) => (item.id || item._id) === editingField
      );
      setSelectedItem(currItem);
    }
  }, [editingField]);

  // A reassessment refreshes the saved form while this sidebar may remain open.
  // Refresh only grading values, preserving other edits in the selected field.
  useEffect(() => {
    const savedField = form?.fields?.find(item => item._id === editingField);
    if (!savedField) return;
    setSelectedItem(previous => (previous?._id || previous?.id) === editingField ? {
      ...previous,
      examQuestionHasRightAnswer: savedField.details.examQuestionHasRightAnswer || false,
      examQuestionRightAnswer: savedField.details.examQuestionRightAnswer || '',
    } : previous);
  }, [form, editingField]);

  const handleChangeOptionField = useCallback(
    (val, id) => {
      setSelectedItem((prevState) => {
        const newSelectionList = prevState.selectionList.map((item) =>
          (item._id || item.id) === id ? { ...item, title: val } : item
        );

        // updateItems({ selectionList: newSelectionList });

        let newExamQuestionRightAnswer = prevState.examQuestionRightAnswer;
        if (
          prevState.type === "RadioButton" &&
          prevState.examQuestionHasRightAnswer &&
          newExamQuestionRightAnswer &&
          !newSelectionList.some(
            (item) => item.title === newExamQuestionRightAnswer
          )
        ) {
          newExamQuestionRightAnswer = "";
        }
        return {
          ...prevState,
          selectionList: newSelectionList,
          examQuestionRightAnswer: newExamQuestionRightAnswer,
        };

        // return {
        //   ...prevState,
        //   selectionList: newSelectionList,
        // };
      });
    },
    [updateItems]
  );

  const handleChangeSelectionList = (selectionListItem) => {
    const updatedSelectionList = selectedItem.selectionList.map((item) =>
      (item._id || item.id) === (selectionListItem._id || selectionListItem.id)
        ? selectionListItem
        : item
    );

    let newExamQuestionRightAnswer = selectedItem.examQuestionRightAnswer;
    if (
      selectedItem.type === "RadioButton" &&
      selectedItem.examQuestionHasRightAnswer &&
      newExamQuestionRightAnswer &&
      !updatedSelectionList.some(
        (item) => item.title === newExamQuestionRightAnswer
      )
    ) {
      newExamQuestionRightAnswer = "";
    }

    setSelectedItem({
      ...selectedItem,
      selectionList: updatedSelectionList,
      examQuestionRightAnswer: newExamQuestionRightAnswer,
    });

    // setSelectedItem({
    //   ...selectedItem,
    //   selectionList: updatedSelectionList,
    // });

    // updateItems({
    //   selectionList: updatedSelectionList,
    // });
  };

  const handleDeleteOptionField = (id) => {
    if (selectedItem.selectionList.length > 1) {
      const newSelectionList = selectedItem.selectionList.filter(
        (item, _) => (item._id || item.id) !== id
      );
      let newExamQuestionRightAnswer = selectedItem.examQuestionRightAnswer;
      if (
        selectedItem.type === "RadioButton" &&
        selectedItem.examQuestionHasRightAnswer &&
        newExamQuestionRightAnswer &&
        !newSelectionList.some(
          (item) => item.title === newExamQuestionRightAnswer
        )
      ) {
        newExamQuestionRightAnswer = "";
      }
      setSelectedItem({
        ...selectedItem,
        selectionList: newSelectionList,
        examQuestionRightAnswer: newExamQuestionRightAnswer,
      });
      // setSelectedItem({
      //   ...selectedItem,
      //   selectionList: newSelectionList,
      // });
      // updateItems({ selectionList: newSelectionList });
    }
  };

  const moveItem = (fromIndex, toIndex) => {
    const updatedList = [...selectedItem.selectionList];
    const [movedItem] = updatedList.splice(fromIndex, 1);
    updatedList.splice(toIndex, 0, movedItem);

    setSelectedItem({
      ...selectedItem,
      selectionList: updatedList,
    });
    // updateItems({ selectionList: updatedList });
  };

  const getConditionField = () => {
    if (selectedItem.visibilityConditionSource !== "") {
      let el = null;
      const currItem = formFields[selectedItem?.visibilityConditionSource];
      if (currItem.type === "Textfield" || currItem.type === "TextArea") {
        el = (
          <TextField
            id="conditionValue"
            label="مقدار شرطی"
            variant="outlined"
            className={classes.formControl}
            value={selectedItem.visibilityConditionValue}
            onChange={(e) => {
              setSelectedItem({
                ...selectedItem,
                visibilityConditionValue: e.target.value,
              });
              // updateItems({ visibilityConditionValue: e.target.value });
            }}
          />
        );
      } else if (
        currItem.type === "CheckBox" ||
        currItem.type === "RadioButton"
      ) {
        el = (
          <CustomSelect
            title={"مقدار شرطی"}
            value={selectedItem?.visibilityConditionValue}
            handleChange={(val) => {
              setSelectedItem({
                ...selectedItem,
                visibilityConditionValue: val,
              });
              // updateItems({ visibilityConditionValue: val });
            }}
            options={currItem.selectionList.map((item) => {
              return { value: item.title, text: item.title };
            })}
          />
        );
      }
      return el;
    }
  };

  const getFieldByType = () => {
    let field = null;
    if (
      selectedItem.type === "Textfield" ||
      selectedItem.type === "TextArea" ||
      selectedItem.type === "Phone" ||
      selectedItem.type === "Number"
    ) {
      field = (
        <>
          <Typography className={classes.textFieldLabel}>
            متن جایگزین
          </Typography>
          <TextField
            id="fieldTitle"
            label="متن جایگزین"
            variant="outlined"
            className={classes.formControl}
            value={selectedItem.placeHolder}
            onChange={(e) => {
              setSelectedItem({ ...selectedItem, placeHolder: e.target.value });
              updateItems({ placeHolder: e.target.value });
            }}
          />
        </>
      );
    } else if (
      selectedItem.type === "CheckBox" ||
      selectedItem.type === "RadioButton"
    ) {
      field = (
        <>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"16px"}
          >
            <Typography className={classes.textFieldLabel}>گزینه ها</Typography>

            <IconButton
              aria-label="add"
              color="primary"
              size="small"
              onClick={() => {
                const items = [...selectedItem.selectionList];
                items.push({
                  title: "گزینه",
                  id: generateUniqueId(),
                  limits: {
                    date: false,
                    startDate: dateFormat,
                    endDate: dateFormat,
                    count: false,
                    countLimit: 0,
                  },
                });
                setSelectedItem({
                  ...selectedItem,
                  selectionList: items,
                });
                updateItems({ selectionList: items });
              }}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </Box>
          {selectedItem.selectionList &&
            selectedItem.selectionList.map((item, index) => (
              <FieldOption
                key={item._id}
                item={item}
                index={index}
                handleChangeOptionField={handleChangeOptionField}
                handleDeleteOptionField={handleDeleteOptionField}
                handleChangeSelectionList={handleChangeSelectionList}
                moveItem={moveItem}
              />
            ))}
          {selectedItem?.examQuestion && selectedItem.type === "RadioButton" && (
            <Box marginTop={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedPolicy ? advancedPolicy.mode !== 'exclude' : !!selectedItem.examQuestionHasRightAnswer}
                    disabled={!!advancedPolicy}
                    onChange={(e) => {
                      setSelectedItem({
                        ...selectedItem,
                        examQuestionHasRightAnswer: e.target.checked,
                        examQuestionRightAnswer: e.target.checked
                          ? selectedItem.examQuestionRightAnswer
                          : "",
                      });
                      updateItems({
                        examQuestionHasRightAnswer: e.target.checked,
                        examQuestionRightAnswer: e.target.checked
                          ? selectedItem.examQuestionRightAnswer
                          : "",
                      });
                    }}
                    name="examQuestionHasRightAnswer"
                    color="primary"
                  />
                }
                label="سوال دارای پاسخ صحیح است"
              />
              {(selectedItem.examQuestionHasRightAnswer || advancedPolicy) && (
                <Box marginTop={2}>
                  <CustomSelect
                    title="پاسخ صحیح"
                    value={advancedPolicy ? '__saved_scoring_policy__' : selectedItem.examQuestionRightAnswer || ""}
                    disabled={!!advancedPolicy}
                    handleChange={(val) => {
                      setSelectedItem({
                        ...selectedItem,
                        examQuestionRightAnswer: val,
                      });
                      updateItems({ examQuestionRightAnswer: val });
                    }}
                    options={
                      advancedPolicy ? [{ value: '__saved_scoring_policy__', text: policyText }] : selectedItem.selectionList
                        ? selectedItem.selectionList.map((item) => ({
                            value: item.title,
                            text: item.title,
                          }))
                        : []
                    }
                  />
                  {advancedPolicy && <Typography variant="caption" color="textSecondary" component="p" style={{ marginTop: 8 }}>
                    این روش در بازبینی آزمون ثبت شده است. برای تغییر آن از «بازبینی پاسخ‌های آزمون» استفاده کنید.
                  </Typography>}
                </Box>
              )}
            </Box>
          )}
        </>
      );
    } else if (selectedItem.type === "File") {
      field = (
        <>
          <Typography className={classes.textFieldLabel}>نوع فایل</Typography>
          <CustomSelect
            title={"نوع فایل"}
            hideTitle
            value={selectedItem.fileType}
            handleChange={(val) => {
              setSelectedItem({ ...selectedItem, fileType: val });
              updateItems({ fileType: val });
            }}
            options={[
              { value: "image", text: "تصویر" },
              { value: "video", text: "ویدیو" },
              { value: "audio", text: "صوت" },
              { value: "pdf", text: "PDF" },
              { value: "doc", text: "Word" },
              { value: "excel", text: "Excel" },
              { value: "all", text: "همه" },
            ]}
          />
        </>
      );
    }
    return field;
  };

  return (
    <DndProvider backend={HTML5Backend}>
      {editingField && selectedItem.hasOwnProperty("title") ? (
        <>
          <Box width={"100%"} marginBottom={"16px"}>
            <Typography className={classes.textFieldLabel}>عنوان</Typography>
            <TextField
              id="fieldTitle"
              label="عنوان"
              variant="outlined"
              className={classes.formControl}
              value={selectedItem.title}
              onChange={(e) => {
                setSelectedItem({ ...selectedItem, title: e.target.value });
                // updateItems({ title: e.target.value });
              }}
            />
          </Box>
          <Box width={"100%"} marginBottom={"16px"}>
            <Typography className={classes.textFieldLabel}>زیرعنوان</Typography>
            <TextField
              id="fieldTitle"
              label="زیرعنوان"
              variant="outlined"
              className={classes.formControl}
              value={selectedItem.subtitle}
              onChange={(e) => {
                setSelectedItem({ ...selectedItem, subtitle: e.target.value });
                // updateItems({ subtitle: e.target.value });
              }}
            />
          </Box>
          <Box width={"100%"} marginBottom={"16px"}>
            <Typography className={classes.textFieldLabel}>توضیحات</Typography>
            <TextField
              id="fieldTitle"
              label="توضیحات"
              variant="outlined"
              className={classes.formControl}
              value={selectedItem.desc}
              multiline={true}
              rows={4}
              onChange={(e) => {
                setSelectedItem({ ...selectedItem, desc: e.target.value });
                // updateItems({ desc: e.target.value });
              }}
            />
          </Box>
          <Box width={"100%"} marginBottom={"16px"}>
            {getFieldByType()}
          </Box>
          {selectedItem.type !== "Text" && (
            <>
              <Box width={"100%"} marginBottom={"16px"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={"ضروری"}
                      checked={selectedItem?.required}
                      onChange={(e) => {
                        setSelectedItem({
                          ...selectedItem,
                          required: e.target.checked,
                        });
                        // updateItems({ required: e.target.checked });
                      }}
                    />
                  }
                  label={"ضروری"}
                />
              </Box>

              {/* VisibilityCondition */}

              <Box width={"100%"} marginBottom={"16px"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={"نمایش شرطی"}
                      checked={selectedItem?.visibilityCondition}
                      onChange={(e) => {
                        setSelectedItem({
                          ...selectedItem,
                          visibilityCondition: e.target.checked,
                        });
                        updateItems({ visibilityCondition: e.target.checked });
                      }}
                    />
                  }
                  label={"نمایش شرطی"}
                />
              </Box>
              {selectedItem?.visibilityCondition && (
                <>
                  <Box width={"100%"} marginBottom={"16px"}>
                    <CustomSelect
                      title={"نمایش شرطی"}
                      value={selectedItem?.visibilityConditionSource}
                      handleChange={(val) => {
                        setSelectedItem({
                          ...selectedItem,
                          visibilityConditionSource: val,
                        });
                        updateItems({ visibilityConditionSource: val });
                      }}
                      options={formFields.map((item, index) => {
                        return { value: index, text: item.title };
                      })}
                    />
                  </Box>
                  <Box width={"100%"} marginBottom={"16px"}>
                    {getConditionField()}
                  </Box>
                </>
              )}

              <Box width={"100%"} marginBottom={"16px"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={"سوال آزمون"}
                      checked={selectedItem?.examQuestion}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setSelectedItem({
                          ...selectedItem,
                          examQuestion: isChecked,
                          examQuestionHasRightAnswer: isChecked
                            ? selectedItem.examQuestionHasRightAnswer
                            : false,
                          examQuestionRightAnswer: isChecked
                            ? selectedItem.examQuestionRightAnswer
                            : "",
                        });
                        // updateItems({ required: e.target.checked });
                      }}
                    />
                  }
                  label={"سوال آزمون"}
                />
              </Box>
            </>
          )}

          <Box display={"flex"} justifyContent={"end"} flexWrap="wrap" gridGap={8}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.cancleButton}
              startIcon={<CloseIcon />}
              onClick={() => dispatch(setEditingField(""))}
            >
              لغو
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CreateIcon />}
              onClick={handleSubmitChanges}
            >
              ثبت
            </Button>
          </Box>
        </>
      ) : (
        <Box display={"flex"} justifyContent={"center"} marginY={"48px"}>
          <Typography color="textSecondary">
            موردی را برای ویرایش انتخاب کنید
          </Typography>
        </Box>
      )}
    </DndProvider>
  );
};

export default FieldSettings;
